(async function gwpThings() {

	// console.log('gwpId', gwpId); // ==========================================
	// console.log('gwpPrice', gwpPrice); // ==========================================
	// console.log('gwpStart', new Date(gwpStart)); // ==========================================
	// console.log('gwpEnd', new Date(gwpEnd)); // ==========================================
	// console.log('today', new Date()); // ==========================================

	if ( !gwpId ) return;
	await gwpCartCheck(gwpPrice);
	await gwpCartUpdate(window, window.fetch, gwpId, gwpPrice);

}())


async function gwpCartUpdate(ns, fetch, gwpId, gwpPrice) {

	if ( typeof fetch !== 'function' ) return;

	ns.fetch = function() {
		const response = fetch.apply(this, arguments);
		response.then(async res => {

			const ajaxURL = res.url;
			// console.log('ADD GWP - whatsRunning - ajaxURL', ajaxURL); // ==========================================

			if ( [
					`${window.location.origin}/cart/add`,
					`${window.location.origin}/cart/change`
				].includes(ajaxURL) ) {

				const item = await res.clone().json();

				// console.log('gwpCartUpdate - gwpCartCheck', await gwpCartCheck());
				// console.log('gwpCartUpdate - item', item); // ==========================================
				// console.log('gwpCartUpdate - removed', item.items_removed?.length); // ==========================================

				const now = new Date();
				const start = new Date(gwpStart);
				const end = new Date(gwpEnd);

				// If outside of date range, do nothing
				if ( now < start || now > end ) return;

				// If stuff is removed from cart, do nothing
				if ( item.items_removed?.length >= 1 ) return;

				const cartData  = await gwpCartCheck();
				const cartTotal = (cartData.total_price / 100).toFixed(2);

				// console.log('gwpCartUpdate - cartTotal', cartTotal, gwpPrice); // ==========================================

				const cartItems = item.items ?? Object.keys(item).map(key => [key, item[key]]);

				// console.log('gwpCartUpdate - cartItems', cartItems); // ==========================================

				const findFreeGift = cartItems.findIndex(findGift =>
					findGift.id === parseInt(gwpId, 10)
				);

				// If free gift exists, do nothing
				if ( findFreeGift !== -1 ) return;

				// console.log('findFreeGift', findFreeGift); // ==========================================

				// If cart doesn't reach price threshold, do nothing
				if ( Number(cartTotal) < Number(gwpPrice) ) return;

				// console.log('gwpCartUpdate adding to cart.'); // ==========================================

				await gwpCartAdd(gwpId);

			}
		});

		return response;
	}
}


async function gwpCartAdd(gwpId) {
	let formData = {
		'items': [{
			'id': gwpId,
			'quantity': 1
		}]
	};

	// console.log('gwpCartAdd - formData', formData); // ==========================================

	try {

		const response = await fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(formData)
		});

		if (response.ok) {

			const gwpCartAddData = await response.json();

			// console.log('GWP - response', gwpCartAddData); // ==========================================

			gwpRefreshCartDrawer();

		} else {

			console.error("Failed to add items to the cart");

		}

	} catch (error) {

		console.error("Error adding items to the cart:", error);

	}
}


async function gwpCartCheck() {

	try {

		const response = await fetch("/cart.js", {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const data = await response.json();

			// console.log('gwpCartCheck - data', data); // ==========================================

			return data;

		} else {

			console.error("Failed to add items to the cart");

		}

	} catch (error) {

		console.error("Error adding items to the cart:", error);

	}
}




function gwpRefreshCartDrawer() {
	setTimeout(() => {

		// console.log('refreshing cart drawer'); // ==========================================

		fetch(`?section_id=cart-drawer`)
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html');
			const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
			for (const selector of selectors) {
				const targetElement = document.querySelector(selector);
				const sourceElement = html.querySelector(selector);
				if (targetElement && sourceElement) {
					targetElement.replaceWith(sourceElement);
				}
			}

		}).catch((e) => {
			console.error(e);
		});

	}, 500);
}
